<div style="height: 400px;" id="map"></div>